// @ts-nocheck
import { createAction, createAsyncAction } from '../../../core/store/actionCreators';
import { DESELECT_VOUCHER, FETCH_VOUCHER } from './voucherActionTypes';
import VoucherService from '../services/VoucherService';

export const fetchVoucher = createAsyncAction(FETCH_VOUCHER, async voucherNo => {
  const { data } = await VoucherService.fetchVoucher(voucherNo);
  return data;
});

export const deselectVoucher = createAction(DESELECT_VOUCHER);
